import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { CityParkingCustomerAddressPayload, CityParkingCustomerInfoPayload, CityParkingCustomerProfileResponse } from '../../../models/customer.model';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  CityParkingCustomerTableDto,
  CityParkingCustomerTableQuery,
} from '../../../models/customer/customer-management.model';
import { MapperCustomerManagementService } from '../../../mappers/customer/mapper-customer-management.service';

@Injectable({
  providedIn: 'root',
})
export class ApiCustomerManagementService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly mapper = inject(MapperCustomerManagementService);

  getCityParkingCustomerForTable(query: CityParkingCustomerTableQuery): Observable<CityParkingCustomerTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;

    const status = this.mapper.mapStatusFilter(query.status ?? 'all');
    if (status) params['status'] = status;
    if (query.unassigned) {
      params['unassigned'] = 'true';
    } else {
      if (query.siteId) params['siteId'] = query.siteId;
      if (query.clientId) params['clientId'] = query.clientId;
    }

    return this.apiMethodService.request<CityParkingCustomerTableDto>(
      '/backoffice/getCityParkingCustomerForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getCityParkingCustomerForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getCityParkingCustomerProfileById(
    customerId: number,
  ): Observable<CityParkingCustomerProfileResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingCustomerProfileResponse>(
      '/backoffice/GetCityParkingCustomerProfileById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingCustomerProfileById',
        token: token,
        params: { customerId: customerId },
        headerOnly: false,
      },
    );
  }

  updateCityparkingAddressCustomer(
    body: CityParkingCustomerAddressPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/ManageCityParkingAddressCustomer',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'ManageCityParkingAddressCustomer',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  updateCityParkingCustomerInfo(
    body: CityParkingCustomerInfoPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/ManageCityParkingCustomerInfo',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'ManageCityParkingCustomerInfo',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  DeleteLineMember(
    id: number,
    customerId: number,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/backoffice/DeleteLineMember/${id}`,
      'DELETE',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'DeleteLineMember',
        token: token,
        headerOnly: false,
        params: {
          customerId: customerId,
        },
      },
    );
  }
}
